<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.loteamento"
        ref="DataTable"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'cadastro-loteamento-edit', params: { id: item.id } })"
                color="primary"
                authorize="update-cadastro-loteamento"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                color="danger"
                authorize="destroy-cadastro-loteamento"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

export default {
    created() {

        this.repositories.loteamento = this.getConectaSusRepository('cadastro.localizacao.loteamento')
    },
    data: () => ({
        fields: [
            {
                name: 'nome',
                key: 'nome',
                label: 'Nome',
                searchable: true,
                sortable: true
            },
            {
                name: 'actions',
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
        repositories: {
            loteamento: null,
        },
    }),
    methods: {
        handleDestroy({ id }) {

            const destroy = () => this.repositories.loteamento.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o loteamento?', destroy, this.handleError)
        },
    },
    mixins: [ repository, error ],
}
</script>